import { createAction, createActions } from 'redux-actions';

export const getType = (reduxAction) => {
    return reduxAction().type;
}

export const getLatestPosts = createActions({
    getPostsRequest: (payload) => payload,
    getPostSuccess: (payload) => payload,
    getPostFailure: (error) => error,
});

export const getRelatedPosts = createActions({
    sendRelatedPostsRequest: (payload) => payload,
    getRelatedPostsSuccess: (payload) => payload,
    getRelatedPostsFailure: (error) => error,
});

export const getHighLightPosts = createActions({
    sendRequest: () => undefined,
    getSuccess: (payload) => payload,
    getFailure: (error) => error,
});

export const getPostDetail = createActions({
    sendPostDetailRequest: (payload) => payload,
    getPostDetailSuccess: (payload) => payload,
    getPostDetailFailure: (error) => error,
});

export const createPost = createActions({
    createPostRequest: (payload) => payload,
    createPostSuccess: (payload) => payload,
    createPostFailure: (error) => error,
});

export const updatePost = createActions({
    updatePostRequest: (payload) => payload,
    updatePostSuccess: (payload) => payload,
    updatePostFailure: (error) => error,
});

export const deletePost = createActions({
    deletePostRequest: (payload) => payload,
    deletePostSuccess: (payload) => payload,
    deletePostFailure: (error) => error,
});

export const crawlData = createActions({
    crawlDataRequest: (payload) => payload,
    crawlDataSuccess: (payload) => payload,
    crawlDataFailure: (error) => error,
});

export const checkAuth = createActions({
    setCurrentPage: (payload) => payload,
    login: (payload) => payload,
    logout: (payload) => payload,
})

export const showLoading = createAction('SHOW_LOADING');

export const hideLoading = createAction('HIDE_LOADING');

export const fetchHomePageData = createActions({
    sendHomePageRequest: () => undefined,
    getHomePageSuccess: (payload) => payload,
    getHomePageFailure: (error) => error,
});

export const searchPosts = createActions({
    sendSearchPostsRequest: (payload) => payload,
    getSearchPostsSuccess: (payload) => payload,
    getSearchPostsFailure: (error) => error,
});

export const globalNotification = createActions({
    successNotification: (payload) => payload,
    errorNotification: (payload) => payload,
    hideNotification: () => undefined,
});

// each action above will return:
/*
{
    type: 'getPostsRequest',
},
getType(getLatestPosts.getPostSuccess)
=>
{
    type: 'getPostSuccess',
    payload: {
        name: 'test',
    }
}
*/